import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import RoleProtectedRoute from './RoleProtectedRoute';
import AuthenticatedLayout from '../Layout/AuthenticatedLayout';
import Dashboard from '../../modules/dashboard/pages/Dashboard';
import UserList from '../../modules/user/pages/UserListPage';
import Unauthorized from '../pages/errors/Unauthorized';
import NotFound from '../pages/errors/NotFound';
import TenantListPage from '../../modules/event/pages/EventListPage';
import TenantDetailPage from '../../modules/event/pages/EventDetailPage';
import TenantFormPage from '../../modules/event/pages/EventormPage';
import UserFormPage from '../../modules/user/pages/UserFormPage';
import UserDetailPage from '../../modules/user/pages/UserDetailPage';
import VisitorListPage from '../../modules/visitors/pages/VisitorListPage';
import VisitorFormPage from '../../modules/visitors/pages/VisitorFormPage';
import { VisitorDetailPage } from '../../modules/visitors/pages/VisitorDetailPage';

import { EventProvider } from '../../modules/event/context/EventContext';
import { UserProvider } from '../../modules/user/context/UserContext';
import { VisitorProvider } from '../../modules/visitors/context/VisitorContext';
import { StatisticsProvider } from '../../modules/dashboard/context/DashboardContext';
import { UserRole } from '../../utils/userMapper';
import RoleBasedRedirect from './RoleBasedRedirect';
import ChangePasswordForm from '../../modules/user/components/ChangePasswordForm';
import TicketCheckIn from '../../modules/admin/pages/TicketCheckIn';
import WhatsAppConfig from '../../modules/admin/pages/WhatsAppConfig';
import CouponsPage from '../../modules/admin/pages/CouponsPage';


export const PrivateRoutes: RouteObject[] = [
  {
    path: "/401",
    element: <Unauthorized />,
  },
  {
    path: "/404",
    element: <NotFound />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <RoleBasedRedirect />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={[UserRole.ADMIN]}>
          <AuthenticatedLayout>
            <StatisticsProvider>
              <Dashboard />
            </StatisticsProvider>
          </AuthenticatedLayout>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
  },
  
  {
    path: '/events',
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={[UserRole.ADMIN, UserRole.ORGANIZER]}>
          <AuthenticatedLayout>
            <EventProvider>
              <Outlet />
            </EventProvider>
          </AuthenticatedLayout>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <TenantListPage />,
      },
      {
        path: 'new',
        element: <TenantFormPage />,
      },
      {
        path: ':id',
        element: <TenantDetailPage />,
      },
      {
        path: ':id/edit',
        element: <TenantFormPage />,
      },
    ],
  },
  {
    path: '/users',
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={[UserRole.ADMIN]}>
          <AuthenticatedLayout>
            <UserProvider>
              <Outlet />
            </UserProvider>
          </AuthenticatedLayout>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <UserList />,
      },
      {
        path: 'new',
        element: <UserFormPage />,
      },
      {
        path: ':id',
        element: <UserDetailPage />,
      },
      {
        path: ':id/edit',
        element: <UserFormPage />,
      },
      {
        path: '/users/:id/change-password',
        element: <ChangePasswordForm />,
      },
      {
        path: '/users/change-password',
        element: <ChangePasswordForm />,
      },
    ],
  },
  {
    path: '/visitors',
    element: (
      <ProtectedRoute>
        <RoleProtectedRoute allowedRoles={[UserRole.ADMIN, UserRole.ORGANIZER, UserRole.CUSTOMER]}>
          <AuthenticatedLayout>
            <VisitorProvider>
              <Outlet />
            </VisitorProvider>
          </AuthenticatedLayout>
        </RoleProtectedRoute>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <VisitorListPage />,
      },
      {
        path: 'new',
        element: <VisitorFormPage />,
      },
      {
        path: ':id/edit',
        element: <VisitorFormPage />,
      },
      {
        path: ':id',
        element: <VisitorDetailPage />,
      },
    ],
  },
{
  path: '/tickets',
  element: (
    <ProtectedRoute>
      <RoleProtectedRoute allowedRoles={[UserRole.ADMIN, UserRole.ORGANIZER]}>
        <AuthenticatedLayout>
          <Outlet />
        </AuthenticatedLayout>
      </RoleProtectedRoute>
    </ProtectedRoute>
  ),
  children: [
    {
      path: 'checkin',
      element: <TicketCheckIn />,
    },
  ],
},
{
  path: '/admin/whatsapp',
  element: (
    <ProtectedRoute>
      <RoleProtectedRoute allowedRoles={[UserRole.ADMIN]}>
        <AuthenticatedLayout>
          <WhatsAppConfig />
        </AuthenticatedLayout>
      </RoleProtectedRoute>
    </ProtectedRoute>
  ),
},
{
  path: '/admin/coupons',
  element: (
    <ProtectedRoute>
      <RoleProtectedRoute allowedRoles={[UserRole.ADMIN]}>
        <AuthenticatedLayout>
          <CouponsPage />
        </AuthenticatedLayout>
      </RoleProtectedRoute>
    </ProtectedRoute>
  ),
},
];